import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  checked?: boolean;
};

// TODO: Move this logic to component library
export const Label = styled.div<Props>(
  ({theme, checked}) => css`
    ${theme.typography.labelMedium}
    ${theme.respondTo('md', theme.typography.labelSmall)}
      
    ${checked &&
    css`
      ${theme.typography.labelMediumBold}
      ${theme.respondTo('md', theme.typography.labelSmallBold)}
    `}
  `
);
